import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ["countryIso2", "countryIcon", 'country', 'loading']

  on_country_select(event) {
    this.countryTarget.value = event.currentTarget.dataset.iso2
    this.countryIso2Target.textContent = event.currentTarget.dataset.iso2.toUpperCase()
    this.countryIconTarget.innerHTML = event.currentTarget.querySelector('.icon').outerHTML
  }

  display_loading() {
    this.loadingTarget.classList.remove('d-none');
  }
}